import TemplateListPage from './template-list-page';

export default class WkrListPage extends TemplateListPage {
  protected handleAddToCartSuccess(form: HTMLFormElement): void {
    super.handleAddToCartSuccess(form);
    $(form).closest('tr').find('.js-deleteTemplateForm').remove();
  }
}
